import { c as _c } from "react/compiler-runtime";
import api from "@/actions/api";
import { SearchTypes } from "@/constants/filters";
import { QueryKeys } from "@/constants/queryKeys";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";
type Props = {
  input: string;
  businessType?: SearchTypes;
  realEstateType?: number;
  bedroomsIn?: string;
  // When provided (search page), the full active filters are forwarded so the
  // count matches the listing results. Filter-less contexts omit it.
  searchParams?: URLSearchParams;
};
export function useSearchLocationsByInput(t0) {
  const $ = _c(7);
  const {
    input,
    businessType,
    realEstateType,
    bedroomsIn,
    searchParams
  } = t0;
  const locale = useLocale();
  let t1;
  if ($[0] !== bedroomsIn || $[1] !== businessType || $[2] !== input || $[3] !== locale || $[4] !== realEstateType || $[5] !== searchParams) {
    t1 = getLocationsByInputOptions({
      input,
      businessType,
      realEstateType,
      bedroomsIn,
      locale,
      searchParams
    });
    $[0] = bedroomsIn;
    $[1] = businessType;
    $[2] = input;
    $[3] = locale;
    $[4] = realEstateType;
    $[5] = searchParams;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return useQuery(t1);
}
const getLocationsByInputOptions = ({
  input,
  businessType,
  realEstateType,
  bedroomsIn,
  locale,
  searchParams
}: {
  input: string;
  businessType?: SearchTypes;
  realEstateType?: number;
  bedroomsIn?: string;
  locale: string;
  searchParams?: URLSearchParams;
}) =>
// Guard against non-numeric values to avoid passing NaN downstream
queryOptions({
  queryKey: [QueryKeys.LOCATION_BY_INPUT, input, searchParams ? searchParams.toString() : `${businessType}:${Number.isFinite(realEstateType) ? realEstateType : ""}:${bedroomsIn ?? ""}`],
  queryFn: () => api.locations.getLocationsByInput({
    value: input,
    businessType,
    realEstateType: Number.isFinite(realEstateType) ? realEstateType : undefined,
    bedroomsIn,
    locale,
    searchParams
  }),
  retry: false,
  enabled: !!input && input.length > 2 && (!!businessType || !!searchParams)
});